const SocialNetworkType = {
  GOOGLE: 1,
  FACEBOOK: 2
}
export default SocialNetworkType
